<template>
  <div class="form-box">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item label="销售农产品" prop="cropName" required>
        <span class="form-txt">{{ ruleForm.cropName }}</span>
      </el-form-item>
      <el-form-item label="销售时间" prop="sellDate" required>
        <span class="form-txt">{{
          ruleForm.sellDate | formatDate("yyyy-MM-dd")
        }}</span>
      </el-form-item>
      <el-form-item label="销售数量" prop="totalSales" required>
        <el-input v-model="ruleForm.totalSales" disabled>
          <template slot="append">公斤</template>
        </el-input>
      </el-form-item>
      <el-form-item label="销售去向" prop="sellTypeName" required>
        <el-input v-model="ruleForm.sellTypeSecondLevelName" disabled>
          <template slot="prepend">{{ ruleForm.sellTypeName }}</template>
        </el-input>
      </el-form-item>
      <el-form-item label="销售价格" prop="sellPrice">
        <el-input v-model="ruleForm.sellPrice" disabled>
          <template slot="append">元/公斤</template>
        </el-input>
      </el-form-item>
      <el-form-item label="品牌" prop="companyBrandName">
        <el-input v-model="ruleForm.companyBrandName" disabled></el-input>
      </el-form-item>
      <el-form-item label="操作人" prop="chargeUserId" required>
        <el-select
          class="chargeUser-input"
          v-model="ruleForm.chargeUserId"
          filterable
          disabled
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option
            v-for="item in chargeUserList"
            :key="item.userId"
            :label="item.companyUserName"
            :value="item.userId"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 提交按钮 -->
      <form-btn
        :isShowSaveBtn="false"
        @submitForm="submitForm"
        @deleteForm="deleteForm"
      ></form-btn>
    </el-form>
  </div>
</template>

<script>
import FormBtn from "../components/FormBtn";
import { getStorage } from "@/utils/storage";
import {
  getDetail,
  saveMission,
  getDel,
  saveAndAudit,
} from "@/api/request/snkd.produce";
import { getOperateList } from "@/api/request/snkd.user";
import { formatDate } from "@/utils";
export default {
  name: "SeedingForm",
  components: {
    FormBtn,
  },
  props: {
    isBack: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isBack(val) {
      if (val) {
        this.$router.go(-1);
      }
    },
  },
  data() {
    return {
      curId: "",
      farmId: "",
      companyId: "",
      categoryType: "", // 农事id
      ruleForm: {
        cropName: "",
        sellDate: "",
        sellPrice: "",
        companyBrandName: "",
        sellUserId: "",
        sellType: "",
        sellTypeName: "",
        sellTypeSecondLevelName: "",
        totalSales: "",
        chargeUserId: "",
      },
      rules: {},
      chargeUserList: [],
    };
  },
  mounted() {
    this.curId = this.$route.query.id;
    //获取农场id
    const farminfo = getStorage("FARMINFO");
    if (getStorage("FARMINFO")) {
      this.companyId = farminfo.companyId;
      this.farmId = farminfo.farmId;
    }
    this.getOperateList();
    this.getDetail();
  },
  methods: {
    submitForm(type) {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          console.log("校验通过");
          this.saveForm(type);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**
     * type: 1、保存 2、保存并提交审核
     */
    async saveForm(type) {
      let params = {
        id: this.curId,
        categoryType: this.categoryType,
        chargeUserId: this.ruleForm.chargeUserId,
        sellStashVO: {
          ...this.ruleForm,
          sellDate: formatDate(this.ruleForm.sellDate, "yyyy-MM-dd"),
        },
      };
      if (type === 1) {
        await saveMission(params).then((res) => {
          const { respCode, obj } = res;
          if (respCode === 0) {
            this.$message.success("保存成功");
            this.$router.go(-1);
          }
          console.log(respCode, obj);
        });
      } else {
        await saveAndAudit(params).then((res) => {
          const { respCode, obj } = res;
          if (respCode === 0) {
            this.$message.success("提交审核成功");
            this.$router.go(-1);
          } else if (respCode === 40012) {
            // 审核不成功
            this.auditFail();
          }
          console.log(respCode, obj);
        });
      }
    },
    async getDetail() {
      await getDetail({
        id: this.curId,
        companyId: this.companyId,
      }).then((res) => {
        const { respCode, obj } = res;
        console.log(respCode, obj);

        if (respCode === 0) {
          this.categoryType = obj.categoryType;
          this.ruleForm.cropName = obj.sellStashVO.cropName;
          this.ruleForm.sellDate = obj.sellStashVO.sellDate;
          this.ruleForm.totalSales = obj.sellStashVO.totalSales; //销售重量
          this.ruleForm.sellPrice = obj.sellStashVO.sellPrice;
          this.ruleForm.sellType = obj.sellStashVO.sellType;
          this.ruleForm.sellTypeName = obj.sellStashVO.sellTypeName;
          this.ruleForm.companyBrandName = obj.sellStashVO.companyBrandName;
          this.ruleForm.sellTypeSecondLevelName =
            obj.sellStashVO.sellTypeSecondLevelName;
          this.ruleForm.chargeUserId = obj.chargeUserId;
          this.ruleForm.totalSales = obj.sellStashVO.totalSales;
        }
      });
    },
    async deleteForm() {
      await getDel({
        idList: [this.curId],
      }).then((res) => {
        const { respCode } = res;
        if (respCode === 0) {
          this.$message({
            type: "success",
            message: "删除成功！",
          });
          this.$router.go(-1);
        }
      });
    },
    //操作人列表
    async getOperateList() {
      await getOperateList({
        companyId: this.companyId,
        farmId: this.farmId,
      }).then((res) => {
        const { respCode, obj } = res;
        if (respCode === 0) {
          this.chargeUserList = obj || [];
        }
      });
    },
    auditFail() {
      const h = this.$createElement;
      this.$confirm("", {
        confirmButtonText: "知道了",
        showCancelButton: false,
        customClass: "confirm-dialog",
        message: h("div", [
          h(
            "p",
            {
              style:
                "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
            },
            `审核未通过！`
          ),
          h(
            "p",
            {
              style:
                "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
            },
            [h("span", null, "当前数据未审核成功，请手动重新审核。")]
          ),
        ]),
        type: "warning",
      })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.form-box {
  background: #fff;
  ::v-deep .demo-ruleForm {
    padding: 40px;
    width: 560px;
    margin: 0 auto;
    .form-txt {
      color: #c0c4cc;
    }
    .select-btn {
      border: 1px solid #64c3a4;
      color: #64c3a4;
    }
    .batch-morebtn {
      font-size: 16px;
      color: #333333;
      margin: 40px 0 115px;
      margin-left: 64px;
      .more {
        cursor: pointer;
        display: inline-block;
      }
      .more:hover {
        color: #64c3a4;
        .iconfont {
          color: #64c3a4;
        }
      }
      .iconfont {
        margin: 0 4px;
        vertical-align: -1px;
        margin-left: 9px;
        color: #888888;
      }
    }
    .breed_level {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .item {
        cursor: pointer;
        font-size: 14px;
        color: #666;
        margin: 0 16px 0 0;
        width: 80px;
        height: 80px;
        border-radius: 4px;
        border: 1px solid #e5e5e5;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        margin-bottom: 10px;
        img {
          width: 40px;
        }
        p {
          margin-top: 6px;
          height: 20px;
          line-height: 20px;
        }
      }
      .selected {
        border: 1px solid #64c3a4;
        background: url("../../../assets/images/aviatFarmingList/selected-ico.png")
          no-repeat right 59px;
      }
    }
    .el-input-group__append {
      width: 90px;
      box-sizing: border-box;
      text-align: center;
    }
    .el-date-editor {
      width: 100%;
    }
    .el-button--medium.el-button--text {
      padding: 0;
    }
  }
}
</style>
